import { render } from "./QGroupEdit.vue?vue&type=template&id=1750b173&scoped=true"
import script from "./QGroupEdit.vue?vue&type=script&lang=js"
export * from "./QGroupEdit.vue?vue&type=script&lang=js"

import "./QGroupEdit.vue?vue&type=style&index=0&id=1750b173&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1750b173"

export default script